import {UserProfile} from "../../api/api";
import {createSlice} from "@reduxjs/toolkit";
import {setter} from "../utils/setter";


export interface AdminState {
  users?: UserProfile[]
}

const initialState: AdminState = {}

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setUsers: setter(initialState, 'users')
  }
})
